export default __webpack_public_path__ + "static/media/AR.894b6dfd.jpg";